module.exports = __webpack_public_path__ + "static/media/cruzroja@2x.26b5e7c0.jpg";